import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivationEnd } from '@angular/router';
import { Constants } from 'src/app/_helpers';
import { filter, delay, first } from 'rxjs/operators';
import { DrawService, CommonService, AlertService, AuthenticationService } from 'src/app/_services';
import { NgbDate, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { Location } from "@angular/common";

@Component({
  selector: '.myTicketwrapper',
  templateUrl: './results.component.html'
})
export class ResultsComponent implements OnInit, OnDestroy {

  gameData: any;
  gameDataSubscription: any;
  resultData = [];
  gameList = [];
  numberArray = [{}, {}, {}];
  betData = {};
  gameSelect = '';
  endDateMax: any;
  currentDate: NgbDate;
  fromDate: NgbDate;
  toDate: NgbDate;
  userInfo: any;
  userInfoLocalSubscription: any;
  resultsSubscription: any;
  gameSelectInfo: any;
  accord = [];
  p: number = 1;
  clientCode = Constants.CLIENT_CODE;
  routeSubscription: any;
  iconMapping = [];
  authenticationSubscription: any;
  backButtonStatus = true;
  eveningStartHours = Constants.EVENING_START_HOURS;
  colourMap: any;
  engineName = Constants.DRAW_ENGINE;

  constructor(
    private drawService: DrawService,
    private alertService: AlertService,
    private router: Router,
    private commonService: CommonService,
    private authenticationService: AuthenticationService,
    private calendar: NgbCalendar,
    private _location: Location
  ) {
    let tempUser: any = {};
    this.gameList = [];
    tempUser = JSON.parse(localStorage.getItem('drawGameUserInfo'));
    if(tempUser.aliasName == "www.winlot.in" && Constants.CLIENT_PLAYERWISE_GAMES_MAPPING[tempUser.playerid]) {
      this.engineName = Constants.CLIENT_PLAYERWISE_GAMES_MAPPING[tempUser.playerid].clientWiseGameEngine;
    } else {
      this.engineName = Constants.DRAW_ENGINE;
    }
    // Constants.CLIENT_GAMES_MAPPING[Constants.CLIENT_CODE][Constants.DRAW_ENGINE].forEach(element => {
    Constants.CLIENT_GAMES_MAPPING[Constants.CLIENT_CODE][this.engineName].forEach(element => {
      this.gameList.push({
        gameCode: element,
        dispName: Constants.GAME_DATA[Constants.DRAW_ENGINE][element].dispName,
        gameIcon: Constants.GAME_DATA[Constants.DRAW_ENGINE][element].gameIcon,
      });
    });
    this.colourMap = [
      {
        str: 'B',
        colorBox: 'boxB',
        machineBall: 1,
        numberArray: [],
      },
      {
        str: 'I',
        colorBox: 'boxI',
        machineBall: 2,
        numberArray: [],
      },
      {
        str: 'N',
        colorBox: 'boxN',
        machineBall: 3,
        numberArray: [],
      },
      {
        str: 'G',
        colorBox: 'boxG',
        machineBall: 4,
        numberArray: [],
      },
      {
        str: 'O',
        colorBox: 'boxO',
        machineBall: 5,
        numberArray: [],
      },
    ];
    this.routeSubscription = router.events.pipe(
      filter(e => e instanceof ActivationEnd),
      first()
    ).subscribe(val => {
      let tempVar = <any>val;
      let params = tempVar.snapshot.params;
      if (typeof params.gameCode != 'undefined') {
        this.gameSelect = params.gameCode;
      } else {
        this.gameSelect = this.gameList[0].gameCode;
      }

      this.gameSelectInfo = {
        gameIcon: Constants.GAME_DATA[Constants.DRAW_ENGINE][this.gameSelect].gameIcon,
        gameIcon1: Constants.GAME_DATA[Constants.DRAW_ENGINE][this.gameSelect].gameIcon1,
        gameName: Constants.GAME_DATA[Constants.DRAW_ENGINE][this.gameSelect].dispName,
        class: Constants.GAME_DATA[Constants.DRAW_ENGINE][this.gameSelect].resultClass,
        fromDate: '',
        toDate: '',
      };
      if (typeof params.playerid != 'undefined' && typeof params.playername != 'undefined' &&
        typeof params.sessid != 'undefined' && typeof params.bal != 'undefined' &&
        typeof params.lang != 'undefined' && typeof params.curr != 'undefined' &&
        typeof params.alias != 'undefined' && typeof params.isMobileApp != 'undefined') {
        this.backButtonStatus = false;
      } else {
        this.backButtonStatus = true;
      }
      this.getDrawResult('init');
      this.commonService.iframe_resize();
    });
  }

  ngOnInit() {
    this.commonService.addEngineClass();
    this.userInfoLocalSubscription = this.authenticationService.subscribeuserInfoLocal().subscribe((response) => {
      this.userInfo = response;
      this.commonService.iframe_resize();
    });
    this.gameDataSubscription = this.drawService.subscribeGameData().pipe(
      delay(0),
      filter(response => response != null)).subscribe((response: any) => {
        response.data.responseData.gameRespVOs.forEach(element => {
          if (element.gameCode == this.gameSelect) {
            this.gameData = element;
            if(this.gameData.gameCode == 'BingoSeventyFive3'){
            for (let i = 0; i < this.colourMap.length; i++) {
              this.colourMap[i].numberArray = [];
            }
            for (let i = 0; i < element.numberConfig.range[0].ball.length; i++) {
              let tmp = Math.floor((i * this.colourMap.length) / element.numberConfig.range[0].ball.length);
              this.colourMap[tmp].numberArray.push(element.numberConfig.range[0].ball[i].number);
            }
          }
            this.numberArray = [{}, {}, {}];
            this.betData = {};
            for (let x = 0; x < element.numberConfig.range.length; x++) {
              for (let i = 0; i < element.numberConfig.range[x].ball.length; i++) {
                this.numberArray[x][element.numberConfig.range[x].ball[i].number] = element.numberConfig.range[x].ball[i];
              }
            }
            for (let i = 0; i < element.betRespVOs.length; i++) {
              this.betData[element.betRespVOs[i].betCode] = JSON.parse(JSON.stringify(element.betRespVOs[i]));
              let tempVar = {};
              for (let j = 0; j < this.betData[element.betRespVOs[i].betCode].pickTypeData.pickType.length; j++) {
                tempVar[element.betRespVOs[i].pickTypeData.pickType[j].code] = this.betData[element.betRespVOs[i].betCode].pickTypeData.pickType[j];
              }
              this.betData[element.betRespVOs[i].betCode].pickTypeData.pickType = tempVar;
            }
          }
        });
        this.commonService.iframe_resize();
      });
    this.authenticationService.getUserInfoLocal();
    // this.getDrawResult('init');
    this.commonService.iframe_resize();
  }

  ngOnDestroy(): void {
    if (typeof this.userInfoLocalSubscription != 'undefined') {
      this.userInfoLocalSubscription.unsubscribe();
    }
    if (typeof this.gameDataSubscription != 'undefined') {
      this.gameDataSubscription.unsubscribe();
    }
    if (typeof this.resultsSubscription != 'undefined') {
      this.resultsSubscription.unsubscribe();
    }
    if (typeof this.routeSubscription != 'undefined') {
      this.routeSubscription.unsubscribe();
    }
    if (typeof this.authenticationSubscription != 'undefined') {
      this.authenticationSubscription.unsubscribe();
    }
  }

  getDrawResult(from, selectGameCode = '') {
    this.resultData = [];
    this.accord = [];
    this.p = 1;
    this.currentDate = this.calendar.getToday();
    if (from == 'init' || from == 'select') {
      this.fromDate =this.calendar.getPrev(this.calendar.getToday(), 'd', 10);
      this.toDate = this.currentDate;
    }
    let tempFromDate = this.fromDate.year + '-' + ((this.fromDate.month < 10) ? '0' + this.fromDate.month : this.fromDate.month) + '-' + ((this.fromDate.day < 10) ? '0' + this.fromDate.day : this.fromDate.day) + ' 00:00:00';
    let tempToDate = this.toDate.year + '-' + ((this.toDate.month < 10) ? '0' + this.toDate.month : this.toDate.month) + '-' + ((this.toDate.day < 10) ? '0' + this.toDate.day : this.toDate.day) + ' 23:59:59';
    this.gameSelect = selectGameCode == '' ? this.gameSelect : selectGameCode;
    let temp = {
      'gameCode': selectGameCode == '' ? this.gameSelect : selectGameCode,
      'fromDate': tempFromDate,
      'toDate': tempToDate,
      "orderByOperator": "DESC",
      "orderByType": "draw_datetime",
      "page": 1,
      "size": 100,
    };
    this.resultsSubscription = this.drawService.getDrawResults(temp).subscribe(
      (response: any) => {
        this.gameSelectInfo = {
          gameIcon: Constants.GAME_DATA[Constants.DRAW_ENGINE][this.gameSelect].gameIcon,
          gameIcon1: Constants.GAME_DATA[Constants.DRAW_ENGINE][this.gameSelect].gameIcon1,
          gameName: Constants.GAME_DATA[Constants.DRAW_ENGINE][this.gameSelect].dispName,
          class: Constants.GAME_DATA[Constants.DRAW_ENGINE][this.gameSelect].resultClass,
          fromDate: this.changeDateFormat(tempFromDate, false),
          toDate: this.changeDateFormat(tempToDate, false),
        };
        if (this.gameSelect == Constants.ONE_BY_TWELVE) {
          this.iconMapping = Constants[this.gameSelect + '_ICON_MAPPING'];
        }
        if (typeof response != 'undefined' && response.data.responseCode == 0) {
          this.drawService.getGameData(Constants.DRAW_ENGINE, this.gameSelect);
          response.data.responseData[0].resultData.forEach(element => {
            element.resultInfo.forEach(element1 => {
              let tempVar = element1;
              tempVar.resultDate = element.resultDate;
              this.resultData.push(tempVar);
            });
          });
        }
        this.commonService.iframe_resize();
      }
    );
    this.commonService.iframe_resize();
  }

  changeDateFormat(date, status) {
    if (status == true) {
      date = this.drawService.changeDateFormat(date, '/', status);
    } else {
      date = this.drawService.changeDateFormat(date);
    }
    return date;
  }

  drawWinNumber(winResult) {
    if (typeof winResult != undefined) {
      return winResult.split(',').filter((item) => !isNaN(parseInt(item)));
    }
    return [];
  }

  drawWinNumberDual(winResult, index) {
    if (typeof winResult != undefined) {
      winResult = winResult.split('#');
      return winResult[index].split(',').filter((item) => !isNaN(parseInt(item)));
    }
    return [];
  }

  changeAccordStatus(resultIndex) {
    this.accord[resultIndex] = !this.accord[resultIndex];
    this.commonService.iframe_resize();
  }

  checkAccord(index) {
    if (typeof this.accord[index] == 'undefined') {
      this.accord[index] = false;
    }
    return this.accord[index];
  }

  checkClover(runTimeFlagInfo, num) {
    let status = false;
    if (typeof runTimeFlagInfo != 'undefined' && runTimeFlagInfo != null) {
      for (let i = 0; i < runTimeFlagInfo.length; i++) {
        if (parseInt(num) == runTimeFlagInfo[i].ballValue) {
          status = true;
          break;
        }
      }
    }
    return status;
  }

  sideBetMatchInfo(sidebetMatchInfo, betCode) {
    if (typeof sidebetMatchInfo == 'undefined' || sidebetMatchInfo.length == 0) {
      return '';
    }
    sidebetMatchInfo = sidebetMatchInfo.filter((a) => a.betCode == betCode);
    if(  sidebetMatchInfo.length == 0 ){
      return '';
    }
    if (betCode == "LuckySixFirstBallColor" || betCode == "LuckySixLastBallColor" ||
      betCode == "LuckySixFirstBallEvenOdd" || betCode == "LuckySixLastBallEvenOdd" ||
      betCode == "LuckySixFirstFiveMoreEvenOdd" || betCode == "12/24FirstBallColor" ||
      betCode == "12/24FirstBallEvenOdd" || betCode == "12/24LastBallColor" ||
      betCode == "12/24LastBallEvenOdd" || betCode == "12/24MoreEvenOdd" ||
      betCode == "FirstBallColor" || betCode == "5/90FirstBallOdd/Even" ||
      betCode == "LastBallColor" || betCode == "5/90LastBallOdd/Even" || betCode == "MoreOddEven") {
      return sidebetMatchInfo[0].result.replace(/[^A-Z]+/gi, "");
    }
    if (betCode == "LuckySixFirstBallSum" || betCode == "LuckySixLastBallSum" ||
      betCode == "LuckySixFirstFiveBallSum" || betCode == "12/24FirstBallSum" ||
      betCode == "12/24LastBallSum" || betCode == "5/90FirstBallSum" ||
      betCode == "5/90LastBallSum" || betCode == 'FirstFiveBallSum') {
      let tempArr = sidebetMatchInfo[0].result.split('<');
      return (tempArr[0] == '0' ? '< ' + tempArr[2] : '> ' + tempArr[0]);
    }
  }

  thaiWinningArr(winningNo) {
    let tempArr = winningNo.split(',');
    for (let i = 0; i < tempArr.length; i++) {
      tempArr[i] = tempArr[i].split('#').filter((a) => parseInt(a) >= 0).join('');
    }
    return tempArr;
  }

  pageChange(event) {
    this.p = event;
    this.accord = [];
    this.commonService.iframe_resize();
  }

  drawWinNumber1(winResult) {
    if (typeof winResult != undefined) {
      let tempResult = winResult.split(',');
      let result = [];
      for (let i = 0; i < tempResult.length; i++) {
        let lastTweoNumber = tempResult[i].split('#')[2]/4 == 0 ? '25' : Math.ceil(tempResult[i].split('#')[2]/4);
        let res = this.getAnimalDetails(lastTweoNumber);
        res['number'] = lastTweoNumber;
        //res['joinNumber'] = tempResult[i].split('#');
        let arr1 = tempResult[i].split('#');
        let arr2 = arr1[2].split('');
        let str1 = arr1[0] + arr1[1] + arr2[0] + arr2[1];
        res['joinNumber'] = str1.split('');
        result.push(res);
      }
      return result;
    }
    return [[], []];
  }

  getAnimalDetails(num) {
    let numArray = [];
    let name = '';
    for(let i of Object.values(this.numberArray[2])) {
      if(i['label'].split(',')[1] == num) {
        name = i['label'].split(',')[0];
        numArray.push(i['number']);
      }
    }
    return {name: name, numArray: numArray };
  }

  loadBack() {
    if (this.drawService.fromLobby) {
      this.router.navigate(['/dge/lobby']);
    } else {
      //this.commonService.redirectParent('loadBackUrl');
      this._location.back();
      this.commonService.appLobbyBack();
    }
  }
  checkResultMachineBall(num) {
    // console.log( this.colourMap,"wwwwwwwwwwww")
    if (typeof this.gameData != 'undefined') {
      let index = Math.floor(((parseInt(num) - 1) * this.colourMap.length) / this.gameData.numberConfig.range[0].ball.length);
      return this.colourMap[index];
    }
    return {};
  }

  numberWithSpaces(x) {
    // Parse the input as a float
    let number = parseFloat(x);
    if (number % 1 === 0) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    } else {
      let formattedNumber = number.toFixed(2).toString().replace(".", ",");
      return formattedNumber.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }
  }

}


